import { createCrudSlice, createCrudSelectors } from "./CrudRedux";
import { createSelector } from "@reduxjs/toolkit";

const entityClassesSlice = createCrudSlice({
  name: "entityClasses",
});

export const EntityClassesActions = entityClassesSlice.actions;

export const EntityClassesSelectors = {
  ...createCrudSelectors({ name: "entityClasses" }),
  getByTypeId: (typeId) => (state) => {
    if (!typeId) return []
    const entityClassesState = state?.entityClasses?.entityClasses
    if (!entityClassesState) return []
    return entityClassesState
      .filter((ec) => ec && ec.typeId === typeId)
      .sort((a, b) => (a.name || "").localeCompare(b.name || ""))
  },
};

export default entityClassesSlice.reducer;
